import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router-dom';

import queryString from 'query-string';

import CustomBreadcrumb from 'components/base/CustomBreadcrumb';
import {
  getCampaignCreateSuccessStepBar,
  getCampaignStepBarNameWithType,
} from 'components/base/prompt/NextStepConfig';
import BaseForm from 'components/base/v2/BaseForm';
import {
  URLFilterKeys,
  URLFragments,
} from 'components/campaign/CampaignUrlConfig';
import { createCampaignBreads } from 'config/CustomBreadConfig';
import { APIStatus, CampaignType } from 'config/CustomEnums';
import { PermissionCodes } from 'config/PermissionCodes';
import {
  removeDataFromSessionStorage,
  saveDataToSessionStorage,
  sessionDataKey,
} from 'models/CreateCampaignModel';

import { createAction } from 'utils';

import './CreateCampaign.scss';
import CreateCampaignStepOneV2 from 'components/campaign/campaignCreation/CreateCampaignStepOneV2';
import CreateCampaignStepTwoV2 from 'components/campaign/campaignCreation/CreateCampaignStepTwoV2';
import CreateCampaignStepThreeV2 from 'components/campaign/campaignCreation/CreateCampaignStepThreeV2';
import CreateCampaignStepFourV2 from 'components/campaign/campaignCreation/CreateCampaignStepFourV2';

function CreateCampaign({
  stepConfig,
  currentStep,
  campaignPublish,
  linkedEarningRules,
  linkedCoupon,
  campaign = {},
  formHasSubmitted,
  hasUpdatedDefaultValues,
}) {
  const params = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const search = queryString.parse(history.location.search);

  const campaignType = campaign.campaignType;
  const campaignId = campaign.pk;
  const campaignGeneralName = campaign.translations?.en?.generalName;

  useEffect(() => {
    dispatch({ type: 'createCampaign/clearData' });
    if (!history.location.search) {
      const campaignId = params.id;
      if (campaignId) {
        dispatch(
          createAction('createCampaign/getOneCampaign')({ id: campaignId }),
        );
      } else {
        dispatch(
          createAction('createCampaign/loadCampaignFromCookie')({
            resume: location.state?.resume,
          }),
        );
      }
      dispatch(createAction('brand/getCurrentPageBrands')());
    }
    dispatch(createAction('language/getList')({ isSelectorLoad: true }));
    return () => {
      console.log('@96');
      dispatch({ type: 'createCampaign/clearData' });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const stepSet = [
    <CreateCampaignStepOneV2 />,
    <CreateCampaignStepTwoV2 />,
    <CreateCampaignStepThreeV2 />,
    <CreateCampaignStepFourV2 />,
  ];

  const toCampaignList = () => {
    const search = queryString.stringify({
      [URLFilterKeys.type]: CampaignType.allTypes,
      [URLFilterKeys.page]: 1,
      [URLFilterKeys.searchKey]: '',
      [URLFilterKeys.rank]: true,
    });
    history.push({
      pathname: '/campaigns',
      hash: URLFragments.list,
      search: search,
    });
  };

  const getCompleteSteps = () => {
    const urlCampaignType = search.type;
    const urlId = search.id;
    const linkedId =
      CampaignType.couponsCampaign === campaignType
        ? linkedCoupon?.pk
        : linkedEarningRules?.pk;
    let showMoreSteps = location.search;
    if (urlCampaignType !== campaignType) {
      showMoreSteps = false;
    }
    if (urlId + '' !== linkedId + '') {
      showMoreSteps = false;
    }
    return getCampaignCreateSuccessStepBar(campaignType, showMoreSteps);
  };

  return (
    <BaseForm
      defaultValues={campaign}
      formHasSubmitted={formHasSubmitted}
      hasUpdatedDefaultValues={hasUpdatedDefaultValues}
      tempSave={(save, getValues) => {
        if (save) {
          saveDataToSessionStorage(getValues());
        } else {
          removeDataFromSessionStorage();
        }
      }}
      showFinishPop={campaignPublish === APIStatus.success}
      nextStepConfig={{
        title: 'Successfully Published!',
        description:
          'The campaign is successfully published.\n Let your customers know about the campaign.',
        steps: {
          stepNames: getCompleteSteps(),
          current: getCampaignStepBarNameWithType(campaignType),
        },
        onHide: () => {},
        buttons: [
          {
            text: 'Create message',
            action: () => {
              history.push({
                pathname: '/messages/create',
                search: `${location.search}&campaign=${campaignId}${
                  location.search ? '' : '&type=' + campaignType
                }`,
              });
            },
            requires: PermissionCodes.addMessage,
          },
          {
            text: 'Maybe Later',
            action: toCampaignList,
            requires: PermissionCodes.changeEarningRule,
          },
        ],
      }}
      continueCreateConfig={{
        onConfirm: () => {
          history.push(history.location.state?.from);
        },
        onCancel: toCampaignList,
        onClose: toCampaignList,
      }}
      sessionDataKey={sessionDataKey}
      content={stepSet}
      currentStep={currentStep}
      breadcrumb={
        <CustomBreadcrumb
          breadcrumbs={createCampaignBreads(
            campaignId ? campaignGeneralName : 'Create Campaign',
          )}
        />
      }
      stepsConfig={stepConfig}
      caution={{
        detail: '',
        title: campaignId ? campaignGeneralName : 'Create Campaign',
      }}
      hasleavePagePrompt={params.id}
    />
  );
}

const mapPropsToState = (state) => ({
  stepConfig: state.createCampaign.stepConfig,
  currentStep: state.createCampaign.currentStep,
  linkedEarningRules: state.createCampaign.campaign?.linkedEarningRules,
  linkedCoupon: state.createCampaign.campaign?.linkedCoupon,
  campaignPublish: state.createCampaign.campaignPublish,

  campaign: state.createCampaign.campaign,
  formHasSubmitted: state.createCampaign.formHasSubmitted,
  hasUpdatedDefaultValues: state.createCampaign.hasUpdatedDefaultValues,
});

export default connect(mapPropsToState)(CreateCampaign);
